export const COOKIE_CONSENT_KEY = 'ylp.cookieConsent.v2';
export const COOKIE_CONSENT_EVENT = 'ylp:cookie-consent-changed';
export const COOKIE_SETTINGS_EVENT = 'ylp:cookie-settings';
export const CONSENT_LIFETIME = 180 * 24 * 60 * 60 * 1000;
let sessionConsent = null;

export function parseCookieConsent(raw, now = Date.now()) {
    try {
        const value = JSON.parse(raw);
        if (value?.version !== 2 || typeof value.analytics !== 'boolean' || typeof value.marketing !== 'boolean' || !Number.isFinite(value.savedAt) || value.savedAt > now || now - value.savedAt >= CONSENT_LIFETIME) return null;
        return value;
    } catch {
        return null;
    }
}

export function getCookieConsent() {
    try {
        return parseCookieConsent(window.localStorage.getItem(COOKIE_CONSENT_KEY)) || parseCookieConsent(JSON.stringify(sessionConsent));
    } catch {
        return parseCookieConsent(JSON.stringify(sessionConsent));
    }
}

export function saveCookieConsent({analytics, marketing}) {
    const value = {version: 2, analytics: analytics === true, marketing: marketing === true, savedAt: Date.now()};
    sessionConsent = value;
    try {
        window.localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(value));
        window.localStorage.removeItem('gdprConsent');
    } catch {}
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, {detail: value}));
    return value;
}

export function openCookieSettings() {
    window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
}

export function hasTrackingConsent(consent = getCookieConsent()) {
    return consent?.analytics === true && consent?.marketing === true;
}

export function getAnalyticsReferrerPolicy() {
    return hasTrackingConsent() ? 'no-referrer-when-downgrade' : 'no-referrer';
}
